import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=a815b9dc&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=a815b9dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a815b9dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a815b9dc')) {
      api.createRecord('a815b9dc', component.options)
    } else {
      api.reload('a815b9dc', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=a815b9dc&scoped=true&", function () {
      api.rerender('a815b9dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-29ZFcY97A4d0y/JS/comp/PopupDialog.vue"
export default component.exports